(function () {
  document.querySelectorAll('[data-fit-guide]').forEach((guide) => {
    const { productSku: sku, apiUrl, store } = guide.dataset;
    const guideContent = guide.querySelector('[data-fit-guide-content]');
    const sizingFitEl = guide.querySelector('[data-fit-sizing-fit]');

    const showSizingFit = () => {
      if (!sizingFitEl || !sizingFitEl.textContent.trim()) {
        guide.hidden = true;
        return;
      }

      guideContent?.remove();
      sizingFitEl.hidden = false;
    };

    if (!sku || !apiUrl || !store) {
      showSizingFit();
      return;
    }

    const getFitLabel = (segment, options = []) => {
      const [small = 'Small', trueToSize = 'True to Size', large = 'Large'] = options;
      if (segment <= 2) return small;
      if (segment >= 4) return large;
      return trueToSize;
    };

    fetch(`${apiUrl}?store=${encodeURIComponent(store)}&sku=${encodeURIComponent(sku)}&type=product_review&per_page=1&include_subrating_breakdown=true`)
      .then((response) => response.ok ? response.json() : Promise.reject())
      .then((data) => {
        // Use pre-aggregated stats (covers all reviews, not just the first page)
        const fitStat = (data.stats?.attributes || []).find((attribute) => {
          const label = attribute.question || attribute.label || '';
          return label.toLowerCase().includes('fit');
        });

        if (fitStat?.average_rating && Number(fitStat.count) > 0) {
          const segment = Math.min(5, Math.max(1, Math.round(parseFloat(fitStat.average_rating))));
          guide.querySelectorAll('.guide__line span').forEach((span, i) => {
            span.classList.toggle('is-active', i + 1 === segment);
          });
          const resultEl = guide.querySelector('[data-fit-review-count]');
          if (resultEl) {
            const fitLabel = getFitLabel(segment, fitStat.options);
            const reviewLabel = `${fitStat.count} review${Number(fitStat.count) === 1 ? '' : 's'}`;
            resultEl.textContent = '';
            resultEl.title = `Based on ${reviewLabel}`;
            resultEl.setAttribute('aria-label', `${fitLabel}, based on ${reviewLabel}`);
          }
          return;
        }

        // No Reviews.io fit data — show custom.sizing_fit metafield if available
        showSizingFit();
      })
      .catch(() => {
        // API error — show custom.sizing_fit metafield if available
        showSizingFit();
      });
  });
})();
